import { useEventListener } from "@/hooks";
import { DIALOGS, type DialogType } from "@/types";
import { Dialog } from "@/components";
import { useState } from "react";
import { DIALOG_EVENTS, type DialogOpenPayload } from "@/events";
import { DIALOG_COMPONENTS } from "./dialogComponents";

const DIALOG_TITLES: Partial<Record<DialogType, string>> = {
    [DIALOGS.ADBLOCKER_DETECTED]: "Adblocker Detected",
    [DIALOGS.CANCEL_EXIT_CONFIRM]: "Confirm Cancel Withdrawal",
    [DIALOGS.CHANGE_DURATION_CONFIRM]: "Confirm Lock",
    [DIALOGS.CHANGE_DURATION_FORM]: "Change duration",
    [DIALOGS.CLAIM_CONFIRM]: "Confirm claim",
    [DIALOGS.DEPOSIT_CONFIRM]: "Confirm Stake",
    [DIALOGS.DEPOSIT_MORE_FORM]: "Deposit more",
    [DIALOGS.EXIT_FEEDBACK]: "Please share your feedback",
    [DIALOGS.EXIT_RETAIN_WHALE]: "Leaving so soon?",
    [DIALOGS.JOIN_WAITLIST]: "Join the waitlist",
    [DIALOGS.LOCK_CONFIRM]: "Confirm Lock",
    [DIALOGS.LOCK_FORM]: "Lock",
    [DIALOGS.LOCK_MORE_FORM]: "Lock more",
    [DIALOGS.MINT_CONFIRM]: "Confirm mint",
    [DIALOGS.REALLOCATE_POINTS]: "Reassign your referral code",
    [DIALOGS.REDEEM_CONFIRM]: "Confirm redemption",
    [DIALOGS.REDEEM_FORM_ALT]: "Limited Redemption Availability",
    [DIALOGS.REDEEM_FORM]: "Redeem",
    [DIALOGS.VOTE_SUBMIT]: "Submit your vote",
    [DIALOGS.WAITLIST_INTERCEPTOR]: "Submit your referrer code",
    [DIALOGS.WITHDRAW_CONFIRM]: "Confirm withdrawal",
    [DIALOGS.WITHDRAW_FORM]: "Choose withdrawal amount",
    [DIALOGS.WITHDRAW_LOCK_CONFIRM]: "Confirm Unlock",
    [DIALOGS.WITHDRAW_LOCK_FORM]: "Choose Unlock Amount",
    [DIALOGS.WITHDRAW_UNWOUND_CONFIRM]: "Finalize withdrawal",
};

export function DialogPortal() {
    const [activeDialog, setActiveDialog] = useState<DialogType | null>(null);
    const [dialogProps, setDialogProps] = useState<Record<string, unknown> | null>(null);

    const handleCloseDialog = () => {
        setActiveDialog(null);
    };

    const handleOpenDialog = (dialog: DialogType, props: Record<string, unknown>) => {
        props.onClose = handleCloseDialog;
        setActiveDialog(dialog);
        setDialogProps(props);
    };

    useEventListener(DIALOG_EVENTS.OPEN, (payload: DialogOpenPayload) => {
        handleOpenDialog(payload.dialogType, payload.props as unknown as Record<string, unknown>);
    });

    useEventListener(DIALOG_EVENTS.CLOSE, () => {
        handleCloseDialog();
    });

    if (!activeDialog) return null;

    const DialogComponent = DIALOG_COMPONENTS[activeDialog];
    const dialogTitle = DIALOG_TITLES[activeDialog];

    const forceOpen = !!dialogProps?.forceOpen;

    return (
        <Dialog
            open={true}
            title={dialogTitle}
            onClose={forceOpen ? () => {} : handleCloseDialog}
            disableEscapeKeyDown={forceOpen}
            style={{ zIndex: "var(--z-index-dialog)" }}
        >
            <DialogComponent {...dialogProps} />
        </Dialog>
    );
}
